import { ThemeOptions } from '@mui/material';

import { TAB_BOX_SHADOW_WIDTH } from './constants';

const themeOptions: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1200,
      xl: 1600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        header: {
          backgroundColor: '#FFFFFF',
          color: '#000000DE',
        },
      },
    },
    MuiButtonBase: { defaultProps: { disableRipple: true } },
  },
  focusVisible: {
    /* inner indicator */
    outlineColor: 'white',
    outlineOffset: 0,
    /* outer indicator */
    boxShadow: `0 0 0 ${TAB_BOX_SHADOW_WIDTH} #193146`,
    borderRadius: 4,
  },
  palette: { divider: '#c6c6c6' },
  typography: {
    fontFamily: `'Lato', 'Roboto', sans-serif`,
  },
};

export default themeOptions;
